// IF THIS FILE SCARES YOU - IT'S OKAY, IT SHOULD.
// TODO: Should be auto generated from swagger -- https://www.npmjs.com/package/@kubb/swagger-zod

import { z } from 'zod';

export const ApiErrorDataDtoSchema = z.object({
  errors: z.array(
    z.object({
      error: z.string().optional(),
      detail: z.string().optional(),
    }),
  ),
  requestId: z.string().optional(),
  status: z.number().optional(),
  timestamp: z.number().optional(),
});

export const ApiErrorDataSchema = z.array(z.string());

export const ConfigurationDtoSchema = z.object({
  adultAge: z.number().positive().int(),
  defaultAdults: z.number().int(),
  maxAdults: z.number().int().optional(),
  minChildren: z.number().int(),
  maxChildren: z.number().int(),
  roomCategories: z.array(
    z.object({
      id: z.number().int(),
      sort: z.number().int(),
      name: z.string(),
      subtitle: z.string().optional(),
      teaser: z.string().optional(),
      description: z.string().optional(),
      size: z.string().optional(),
      mediums: z.array(
        z.object({
          title: z.string(),
          description: z.string(),
          variants: z.array(
            z.object({
              type: z.string(),
              format: z.string(),
              width: z.number().int(),
              height: z.number().int(),
              url: z.string().url(),
            }),
          ),
        }),
      ),
      minimumOccupancy: z.number().int(),
      maximumOccupancy: z.number().int(),
      features: z.array(z.number().int()),
      descriptions: z.array(
        z.object({
          id: z.number().int(),
          type: z.string(),
          text: z.string(),
        }),
      ),
    }),
  ),
  roomCategoryFeatures: z.array(
    z.object({
      id: z.number().int(),
      name: z.string(),
      svg: z.string(),
    }),
  ),
  rates: z.array(
    z.object({
      id: z.number().int(),
      name: z.string(),
      description: z.string(),
    }),
  ),
  packageCategories: z.array(
    z.object({
      id: z.number().int(),
      sort: z.number().int(),
      name: z.string(),
      teaser: z.string(),
      description: z.string(),
      packageGroups: z.array(
        z.object({
          id: z.number().int(),
          sort: z.number().int(),
          name: z.string(),
          teaser: z.string(),
          description: z.string(),
          includedServices: z.string(),
          stayRanges: z.array(
            z.object({
              from: z.string(),
              to: z.string(),
            }),
          ),
          packages: z.array(
            z.object({
              id: z.number().int(),
              name: z.string(),
              teaser: z.string(),
              description: z.string(),
              duration: z.number().int(),
              arrivalRanges: z.array(
                z.object({
                  from: z.string(),
                  to: z.string(),
                }),
              ),
              arrivalDays: z.array(
                z.enum([
                  'MONDAY',
                  'TUESDAY',
                  'WEDNESDAY',
                  'THURSDAY',
                  'FRIDAY',
                  'SATURDAY',
                  'SUNDAY',
                ]),
              ),
            }),
          ),
          mediums: z.array(
            z.object({
              title: z.string(),
              description: z.string(),
              variants: z.array(
                z.object({
                  type: z.string(),
                  format: z.string(),
                  width: z.number().int(),
                  height: z.number().int(),
                  url: z.string().url(),
                }),
              ),
            }),
          ),
        }),
      ),
      mediums: z.array(
        z.object({
          title: z.string(),
          description: z.string(),
          variants: z.array(
            z.object({
              type: z.string(),
              format: z.string(),
              width: z.number().int(),
              height: z.number().int(),
              url: z.string().url(),
            }),
          ),
        }),
      ),
    }),
  ),
  lastMinutePackages: z.array(
    z.object({
      id: z.number().int(),
      name: z.string(),
      teaser: z.string(),
      description: z.string(),
      duration: z.number().int(),
      arrivalDay: z.string(),
      mediums: z.array(
        z.object({
          title: z.string(),
          description: z.string(),
          variants: z.array(
            z.object({
              type: z.string(),
              format: z.string(),
              width: z.number().int(),
              height: z.number().int(),
              url: z.string().url(),
            }),
          ),
        }),
      ),
      roomCategoryId: z.number().int(),
    }),
  ),
  extraServices: z.array(
    z.object({
      id: z.number().int(),
      name: z.string(),
      highlight: z.boolean(),
      description: z.string(),
    }),
  ),
  salesInfos: z.array(
    z.object({
      title: z.string(),
      text: z.string(),
      from: z.string(),
      to: z.string(),
    }),
  ),
  pageCustomization: z
    .object({
      hotelName: z.string(),
      phone: z.string(),
      email: z.string(),
      primaryColor: z.string(),
      secondaryColor: z.string(),
      primaryForegroundColor: z.string(),
      secondaryForegroundColor: z.string(),
      mutedColor: z.string(),
      mutedForegroundColor: z.string(),
      accentColor: z.string(),
      accentForegroundColor: z.string(),
      buttonTextColor: z.string(),
      radius: z.string(),
      logoUrl: z.string().url(),
      headerImageUrl: z.string().url(),
      mobileHeaderImageUrl: z.string().url(),
      googleTagManagerTag: z.string(),
      imprintUrl: z.string().url(),
      termsUrl: z.string().url(),
      gdprUrl: z.string().url(),
      contactUrl: z.string().url(),
      cancellationUrl: z.string().url(),
      calendarPastBackground: z.string(),
      calendarPastForeground: z.string(),
      calendarBlockedBackground: z.string(),
      calendarBlockedForeground: z.string(),
      calendarArrivalNotPossibleBackground: z.string(),
      calendarArrivalNotPossibleForeground: z.string(),
      calendarAvailableBackground: z.string(),
      calendarAvailableForeground: z.string(),
    })
    .partial(),
  languages: z.array(
    z.object({
      language: z.string(),
      default: z.boolean(),
    }),
  ),
  countries: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    }),
  ),
  bookingEnabled: z.boolean(),
  inquiryEnabled: z.boolean(),
});

export const OffersDtoSchema = z.object({
  offers: z.array(
    z.object({
      type: z.enum(['ROOM', 'LAST_MINUTE_PACKAGE', 'PACKAGE']).optional(),
      arrivalDay: z.string(),
      departureDay: z
        .object({
          date: z.string(),
          arrivalRestricted: z.boolean(),
          departureRestricted: z.boolean(),
          dayRestricted: z.boolean(),
        })
        .optional(),
      nights: z.number().int(),
      adults: z.number().int().optional(),
      children: z.array(z.number().int()).optional(),
      price: z
        .object({
          amount: z.number(),
          currency: z.string(),
          symbol: z.string(),
        })
        .optional(),
      minimumPrice: z
        .object({
          amount: z.number(),
          currency: z.string(),
          symbol: z.string(),
        })
        .optional(),
      overlayMessages: z.array(z.string()).optional(),
      rateId: z.number().int().optional(),
      roomCategoryId: z.number().int().optional(),
      lastMinutePackageId: z.number().int().optional(),
      packageGroupId: z.number().int().optional(),
      packageCategoryId: z.number().int().optional(),
    }),
  ),
});

export const SessionDtoSchema = z.object({
  sessionId: z.string(),
  user: z
    .object({
      salutation: z.string(),
      title: z.string(),
      firstname: z.string(),
      lastname: z.string(),
      email: z.string(),
      street: z.string(),
      zipcode: z.string(),
      city: z.string(),
      country: z.string(),
      phone: z.string(),
    })
    .partial(),
  erv: z
    .object({
      offers: z.array(
        z.object({
          agreements: z.array(
            z.object({
              agreementText: z.string(),
              agreementTextHtml: z.string(),
              key: z.string(),
              mandatory: z.boolean(),
            }),
          ),
          specification: z.string(),
          description: z.string(),
          documents: z.array(
            z.object({
              key: z.string(),
              label: z.string(),
              text: z.string(),
              url: z.string(),
            }),
          ),
          id: z.string(),
          name: z.string(),
          selected: z.boolean(),
          totalPremium: z.object({
            amount: z.number(),
            currency: z.string(),
            symbol: z.string(),
          }),
          totalPremiumText: z.string(),
        }),
      ),
    })
    .partial()
    .optional(),
  items: z.array(
    z.object({
      id: z.string(),
      type: z.enum(['ROOM', 'LAST_MINUTE_PACKAGE', 'PACKAGE']),
      arrivalDay: z.string(),
      nights: z.number(),
      guests: z.array(
        z
          .object({
            id: z.string(),
            type: z.literal('ADULT'),
            birthdate: z.string().optional(),
            firstname: z.string().optional(),
            lastname: z.string().optional(),
          })
          .or(
            z.object({
              id: z.string(),
              type: z.literal('CHILD'),
              childAge: z.number().int(),
              birthdate: z.string().optional(),
              firstname: z.string().optional(),
              lastname: z.string().optional(),
            }),
          ),
      ),
      roomCategoryId: z.number().int(),
      lastMinutePackageId: z.number().int().optional(),
      packageGroupId: z.number().int().optional(),
      packageCategoryId: z.number().int().optional(),
      rateId: z.number().int(),
      price: z.object({
        amount: z.number(),
        currency: z.string(),
        symbol: z.string(),
      }),
      comment: z.string().optional(),
      overlayMessages: z.array(z.string()),
      bookingMessages: z.array(z.string()),
      alternativeRates: z.array(
        z.object({
          rateId: z.number().int(),
          price: z.object({
            amount: z.number(),
            currency: z.string(),
            symbol: z.string(),
          }),
          overlayMessages: z.array(z.string()),
          bookingMessages: z.array(z.string()),
        }),
      ),
      extraServices: z
        .array(
          z.object({
            id: z.string(),
            extraServiceId: z.number().int(),
            quantity: z.number().int(),
            possibleQuantities: z.array(z.number().int()),
            price: z.object({
              amount: z.number(),
              currency: z.string(),
              symbol: z.string(),
            }),
            pricePerNight: z
              .object({
                amount: z.number(),
                currency: z.string(),
                symbol: z.string(),
              })
              .optional(),
            totalPrice: z.object({
              amount: z.number(),
              currency: z.string(),
              symbol: z.string(),
            }),
          }),
        )
        .optional(),
    }),
  ),
  total: z.object({
    amount: z.number(),
    currency: z.string(),
    symbol: z.string(),
  }),
  deposit: z.object({
    depositPercentage: z.number(),
    depositAmount: z.object({
      amount: z.number(),
      currency: z.string(),
      symbol: z.string(),
    }),
  }),
  promotion: z
    .object({
      code: z.string(),
    })
    .optional(),
});

export const UpdateCartItemDtoSchema = SessionDtoSchema.shape.items.element
  .partial()
  .extend({
    id: SessionDtoSchema.shape.items.element.shape.id,
    guests: z.array(
      z.object({
        id: z.string(),
        type: z.enum(['CHILD', 'ADULT']).optional(),
        childAge: z.number().int().optional(),
        birthdate: z.string().optional(),
        firstname: z.string().optional(),
        lastname: z.string().optional(),
      }),
    ),
  });

export const AddToCartDtoSchema = z.object({
  type: z.enum(['ROOM', 'LAST_MINUTE_PACKAGE', 'PACKAGE']),
  arrivalDay: z.string(),
  nights: z.number().int(),
  adults: z.number().int(),
  children: z.array(z.number().int()),
  price: z.object({
    amount: z.number(),
    currency: z.string(),
    symbol: z.string(),
  }),

  rateId: z.number().int(),
  roomCategoryId: z.number().int(),

  lastMinutePackageId: z.number().int().optional(),
  packageGroupId: z.number().int().optional(),
  packageCategoryId: z.number().int().optional(),
});

export const UpdateUserDtoSchema = z
  .object({
    salutation: z.string(),
    title: z.string(),
    firstname: z.string(),
    lastname: z.string(),
    email: z.string().email().or(z.literal('')),
    street: z.string(),
    zipcode: z.string(),
    city: z.string(),
    country: z.string(),
    phone: z.string(),
  })
  .partial();

export const ValidateCheckoutDtoSchema = z.object({
  total: z.object({
    amount: z.number(),
    currency: z.string(),
    symbol: z.string(),
  }),
});

export const BookDtoSchema = z.object({
  total: z.object({
    amount: z.number(),
    currency: z.string(),
    symbol: z.string(),
  }),
  comment: z.string().optional(),
  successUrl: z.string().url().optional(),
  errorUrl: z.string().url().optional(),
  cancelUrl: z.string().url().optional(),
});

export const PaymentDtoSchema = z.object({
  type: z.string(),
  paymentUrl: z.string().url(),
  parameters: z
    .object({
      brands: z.string(),
      callbackUrl: z.string().url(),
      bookingId: z.string(),
      errorUrl: z.string().url(),
      successUrl: z.string().url(),
    })
    .partial(),
});

export const InquiryDtoSchema = z.object({
  id: z.string(),
});

export const UpdatePromotionDtoSchema = z.object({
  code: z.string(),
});

export const LastBookingDtoSchema = z.object({
  bookingId: z.string(),
  depositAmount: z.object({
    amount: z.number(),
    currency: z.string(),
    symbol: z.string(),
  }),
  id: z.number(),
  items: z.array(
    z.object({
      packageGroupId: z.number().optional(),
      price: z.object({
        amount: z.number(),
        currency: z.string(),
        symbol: z.string(),
      }),
      ratePlanId: z.number(),
      roomCategoryId: z.number(),
      roomCategoryName: z.string(),
    }),
  ),
  status: z.string(),
  total: z.object({
    amount: z.number(),
    currency: z.string(),
    symbol: z.string(),
  }),
});

export const UpdateInsuranceOfferDtoSchema = z.object({
  id: z.string().nullable(),
});
